export const columnOneHeading = "applied app template id"
export const columnTwoHeading = "display title";
export const columnThreeHeading = "assistant response";